/**
 * UI-only food names. Database-style names ("oil, olive", "butter, plain") read back to front, so
 * they are shown reordered ("Olive oil", "Plain butter"). Stored data and matching keep the raw name.
 */
export function displayFoodName(name: string, opts: { capitalize?: boolean } = {}): string {
  const capitalize = opts.capitalize ?? true;
  const parts = (name ?? '')
    .split(',')
    .map((p) => p.trim())
    .filter(Boolean);
  const text = parts.length > 1 ? [...parts].reverse().join(' ') : parts[0] ?? '';
  return capitalize && text ? text.charAt(0).toUpperCase() + text.slice(1) : text;
}

function escapeRegExp(s: string): string {
  return s.replace(/[.*+?^${}()|[\]\\]/g, '\\$&');
}

/**
 * Replaces verbatim occurrences of each item name in free text (plan titles, pattern titles) with its
 * display name. Only names that read differently (comma names) are touched; a name at the very start
 * of the text is capitalised, elsewhere it keeps the text's own case.
 */
export function withDisplayNames(text: string, items: string[]): string {
  let out = text ?? '';
  const names = [...new Set(items.filter((i) => i && i.includes(',')))].sort((a, b) => b.length - a.length);
  for (const item of names) {
    const re = new RegExp(escapeRegExp(item), 'gi');
    out = out.replace(re, (_m, offset: number) => displayFoodName(item, { capitalize: offset === 0 }));
  }
  return out;
}
